module.exports = __webpack_public_path__ + "img/developers-49ee0e9ce6481c6704b6d5c0b80a44a6.svg";